import { CategoryType } from '@habity/types';
import {
  TbBuildingCastle,
  TbBuildingCircus,
  TbBuildingCottage,
  TbBuildingSkyscraper,
  TbShovel,
} from 'react-icons/tb';
import {
  MdBusiness,
  MdChildFriendly,
  MdCottage,
  MdOutlineAirplanemodeActive,
  MdOutlineApartment,
  MdWater,
  MdYard,
} from 'react-icons/md';
import { FaHome, FaTractor, FaTree } from 'react-icons/fa';
import { RiCommunityFill } from 'react-icons/ri';

export const LOG_QUERY_TIME = false;
export const RELATED_HOMES_COUNT = 12;
export const MAX_SEARCH_LIMIT = 10000;
export const MAX_HOMEBUYERS_LIMIT = 150;
export const MAX_MESSAGE_RECIPIENTS = 500;
export const HOMES_COUNT = null; // 3757871; // is_rental_unit = false
export const LOCATIONS_INPUT_MAX_COUNT = 1;
export const SEARCH_HISTORY_MAX_COUNT = 10;

export const FILTER_LIVING_SPACE = {
  MIN: 0,
  MAX: 400,
  STEP: 1,
} as const;

export const FILTER_PRICE = {
  MIN: 0,
  MAX: 50_000_000,
  STEP: 500_000,
} as const;

export const FILTER_ROOMS = {
  MIN: 1,
  MAX: 8,
  STEP: 1,
} as const;

export const FILTER_BEDROOMS = {
  MIN: 1,
  MAX: 8,
  STEP: 1,
} as const;

export const FILTER_PLOT_SIZE = {
  MIN: 0,
  MAX: 5_000,
  STEP: 5,
} as const;

export const FILTER_BUILD_YEAR = {
  MIN: 1_800,
  MAX: 2_025,
  STEP: 1,
} as const;

export const FILTER_MONTHLY_FEE = {
  MIN: 0,
  MAX: 15_000,
  STEP: 25,
} as const;

export const SHORTCUTS = [
  {
    label: 'Sommartorp',
    icon: TbBuildingCottage,
    value: 'summerHouses',
  },
  {
    label: 'Lyxläga',
    icon: TbBuildingSkyscraper,
    value: 'luxuryApartments',
  },
  {
    label: 'Nära flyg',
    icon: MdOutlineAirplanemodeActive,
    value: 'nearAirport',
  },
  {
    label: 'Sekelskiftsdröm',
    icon: TbBuildingCastle,
    value: 'turnOfCentury',
  },
  {
    label: 'Krypin',
    icon: TbBuildingCircus,
    value: 'tinyHouses',
  },
  {
    label: 'Barnvänligt',
    icon: MdChildFriendly,
    value: 'childFriendly',
  },
  {
    label: 'Sjöbris',
    icon: MdWater,
    value: 'seaSide',
  },
];

export const getCategoryIcon = (value: CategoryType) => {
  switch (value) {
    case 'house':
      return FaHome;
    case 'apartment':
      return MdOutlineApartment;
    case 'townhouse':
    case 'twinhouse':
      return RiCommunityFill;
    case 'farm':
      return FaTractor;
    case 'cottage':
      return MdCottage;
    case 'new_construction':
      return TbShovel;
    case 'commercial':
      return MdBusiness;
    case 'plot':
      return MdYard;
    default:
      return MdOutlineApartment;
  }
};

export const EMPTY_HOME = { props: { home: null } };
